export const CHAT_TYPE = { CUSTOMER: 5, SUPPORT: 7, DRIVER: 8 };
export const CHAT_TYPE_IDS = [CHAT_TYPE.SUPPORT, CHAT_TYPE.CUSTOMER, CHAT_TYPE.DRIVER];
// Who wrote a message. BUSINESS is this app's user.
export const ENTITY_TYPE = { CUSTOMER: 0, SUPPORT: 1, DRIVER: 2, BUSINESS: 3 };

const CHAT_CHANNEL_NAMES = {
	[CHAT_TYPE.CUSTOMER]: 'customer_business',
	[CHAT_TYPE.SUPPORT]: 'support_business',
	[CHAT_TYPE.DRIVER]: 'business_driver',
};

// The order code of a conversation about no order (general support).
export const GENERAL_ORDER_CODE = '0';

export const isChatTypeId = (value) => CHAT_TYPE_IDS.includes(value);

export const channelNameOf = (typeId) => CHAT_CHANNEL_NAMES[typeId] || null;

export const typeIdOfChannel = (channelName) => {
	const entry = Object.entries(CHAT_CHANNEL_NAMES).find(([, name]) => name === channelName);
	return entry ? Number(entry[0]) : null;
};

// Chats show customers and drivers by first name only; a courier's name arrives as the full name.
export const firstName = (fullName) => (typeof fullName === 'string' ? fullName.trim().split(/\s+/)[0] : '');

const UNREAD_CAP = 99;

export const unreadBadgeLabel = (count) => (count > UNREAD_CAP ? `${UNREAD_CAP}+` : String(count));

const CHAT_CHANNEL_LABEL_KEYS = {
	[CHAT_TYPE.CUSTOMER]: 'chat.customer',
	[CHAT_TYPE.SUPPORT]: 'chat.support',
	[CHAT_TYPE.DRIVER]: 'chat.driver',
};

export const chatChannelLabelKey = (typeId) =>
	CHAT_CHANNEL_LABEL_KEYS[typeId] || CHAT_CHANNEL_LABEL_KEYS[CHAT_TYPE.SUPPORT];

export const chatDisplayName = (t, typeId, counterpart) => counterpart?.name || t(chatChannelLabelKey(typeId));

export const chatTypeIdOfSender = (entityType) => {
	switch (entityType) {
		case ENTITY_TYPE.CUSTOMER:
			return CHAT_TYPE.CUSTOMER;
		case ENTITY_TYPE.DRIVER:
			return CHAT_TYPE.DRIVER;
		default:
			return CHAT_TYPE.SUPPORT;
	}
};

export const CHAT_ORDER_TYPE_KEYS = { DELIVERY: 'chat.order_delivery', TAKEAWAY: 'chat.order_takeaway' };

export const CHAT_PAYMENT_KEYS = {
	CASH: 'chat.pay_cash',
	CREDIT_CARD: 'chat.pay_card',
	BALANCE: 'chat.pay_balance',
	PAY_PAL: 'chat.pay_paypal',
	BANK: 'chat.pay_bank',
	CREDIT: 'chat.pay_credit',
};

// A chat carries no currency: take the one of the restaurant it names, or the one all of the user's
// restaurants share; '' (no symbol) when it can't tell.
export const chatOrderCurrency = (restaurants, businessName) => {
	const list = Array.isArray(restaurants) ? restaurants.filter(Boolean) : [];
	const named = list.find((restaurant) => restaurant.restaurantName === businessName);
	if (named && named.currency) {
		return named.currency;
	}
	const codes = new Set(
		list.map(({ currency }) => (currency && typeof currency === 'object' ? currency.code : currency))
	);
	return codes.size === 1 && list[0].currency ? list[0].currency : '';
};
